import React, { useEffect, useState} from "react";
import {useNavigate, useOutletContext, useSearchParams} from "react-router-dom";
import veneshLogo from "../../images/venesh_logo_1.png"
import Api from "../../tools/service";
import Container from "../../components/Container";
import LoadingScreen from "../../components/LoadingScreen";
import {MdAlternateEmail} from "react-icons/md";
import {TbWorldWww} from "react-icons/tb";
import venifyLogo from "../../venifyLogo.png";
import WidgetRules from "./WidgetRules";

const DivarInternalReport=()=>{
    const [token,setToken] = useOutletContext();
    const [info,setInfo]=useState();
    const [loading,setLoading]=useState(true)
    const [confirmDate,setConfirmDate]=useState()
    const [searchParams] = useSearchParams();
    const ref=searchParams.get('ref');
    const navigate=useNavigate();
   /* useEffect(()=>{

        if(token){
            getReports()
        }
    },[token]);*/
    useEffect(() => {
        getReports()
    }, []);
    const getReports=()=>{
        setLoading(true)
        Api.get(`api/v1/Public/DivarInternalCar/${ref}`,{
            params:{
                g_response:token,
            }
        }).then(response=>{

            if(!response.hasError){

                setInfo(response.data.info)
                if(response.data?.info?.widget_body?.inquiry_date){
                    setConfirmDate(response.data.info.widget_body.inquiry_date)
                }
            }else{
                navigate('/notfound')
            }
        }).catch(e=>{

        }).finally(()=>{
            setLoading(false)
        })
    }
    if(loading){
        return  <LoadingScreen/>
    }
    return <div className="  ">

        <Container className="flex  font-sm rtl mt-20 items-center  flex-col justify-center">
            <div dir="rtl" className="w-full   ">
                <div className=" items-center w-full mb-2 rounded-xl  flex bg-white p-5  ">
                    <a className="w-16" href="https://venify.ir">
                        <img className="w-16" src={veneshLogo} alt=""/>
                    </a>
                    <div className="flex mr-2 flex-col">
                        <a href="https://venify.ir">
                            <h1 className="text-xl    font-bold  ">ونش</h1>
                        </a>
                        <p className="  text-sm  "> ابر متمرکز خدمات عمومی</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-2 lg:grid-cols-6">
                    {<div className="bg-white p-5 lg:col-span-2 rounded-xl ">
                        <div className="w-full flex mb-3  items-start md:items-center  ">
                            <div className="flex justify-start items-start flex-col w-full ">
                                <h1 className="font-2xl mt-5 font-bold mb-2">تاییدیه اصالت خودرو</h1>

                            </div>
                        </div>
                        <div className="grid grid-cols-1 gap-2">
                            {info?.widget_body?.CarModelInquiry.CarName &&
                                <div className="flex justify-between items-center    py-2 border-t    ">
                                    <span className="text-sm">مدل خودرو</span>
                                    <span className="text-sm font-bold">{info?.widget_body?.CarModelInquiry?.CarName}</span>
                                </div>
                            }
                            {info?.widget_body?.CarModelInquiry?.Color &&
                                <div className="flex justify-between items-center    py-2 border-t">
                                    <span className="text-sm">رنگ خودرو</span>
                                    <span className="text-sm font-bold">{info?.widget_body?.CarModelInquiry?.Color}</span>
                                </div>

                            }
                            {info?.widget_body?.CarModelInquiry?.ProductYear &&
                                <div className="flex justify-between items-center    py-2 border-t    ">
                                    <span className="text-sm">سال تولید</span>
                                    <span
                                        className="text-sm font-bold">{info?.widget_body?.CarModelInquiry?.ProductYear}</span>
                                </div>

                            }
                        
                        </div>

                        <div className="flex flex-col w-full">
                            <div className="flex flex-col">
                                {(info?.widget_body?.im_owner !== undefined && info?.widget_body?.im_owner != null) &&
                                    <div className="flex items-center border-t py-2  justify-between">
                                        <span className="text-sm">آیا آگهی‌گذار مالک خودرو است؟</span>
                                        {info?.widget_body?.im_owner &&
                                            <span className="text-green-500 font-semibold text-sm">بله</span>}
                                        {!info?.widget_body?.im_owner &&
                                            <span className="text-red-500 font-semibold text-sm">خیر</span>}

                                    </div>}
                                {(info?.widget_body?.i_have_access_to_owner !== undefined && info?.widget_body?.i_have_access_to_owner != null) &&
                                    <div className="flex items-center border-t py-2    justify-between">
                                        <span className="text-sm">آیا آگهی‌گذار به مالک دسترسی دارد؟</span>
                                        {info?.widget_body?.i_have_access_to_owner &&
                                            <span className="text-green-500 font-semibold text-sm">بله</span>}
                                        {!info?.widget_body?.i_have_access_to_owner &&
                                            <span className="text-red-500 font-semibold text-sm">خیر</span>}
                                    </div>}


                            </div>
                        </div>
                        <div
                            className="flex items-center  flex-col w-full border-t pt-3 mt-3  ">
                            <div
                                className=" mb-2  w-full flex justify-between items-center text-sm  ">
                                <span className="">تاریخ استعلام  </span>
                                <span className="font-semibold">{confirmDate}</span>
                            </div>

                            {info.btns.map((btn, index) => {
                                return <a href={btn.url} className="w-full  " key={index}>
                                    <button className="p-3 btn btn-blue  w-full text-sm   px-5 rounded-lg   ">
                                        {btn.title}
                                    </button>
                                </a>
                            })}
                        </div>

                    </div>}
                    <WidgetRules/>
                </div>

            </div>
            <div dir="rtl"
                 className="w-full    mt-4 text-sm      text-center flex justify-center items-center flex-col ">
                <div className="grid grid-cols-2 lg:grid-cols-2  w-full  gap-3 ">
                    <div className=" p-5 col-span-1 bg-white flex justify-start items-center text-gray-800 rounded-xl">
                        <TbWorldWww className="text-xl"/>
                        <div className="flex  mr-3 flex-col items-start justify-start">
                            <p className="text-gray-800 mb-1">آدرس وبسایت</p>
                            <a href="https://venesh.ir" className="text-gray-800 font-bold">https://venesh.ir</a>
                        </div>
                    </div>
                    <div className=" p-5 col-span-1 bg-white flex justify-start  items-center text-gray-800 rounded-xl">
                        <MdAlternateEmail className="text-xl"/>
                        <div className="flex mr-3 flex-col items-start justify-start">

                            <p className="text-gray-700 text-sm mb-1">ایمیل</p>
                            <a href="mailto:info@venesh.ir" className=" font-bold">info@venesh.ir</a>
                        </div>
                    </div>
                </div>
                <div className="w-full border-t mt-5 "></div>
                <p className="mt-2 text-sm ">تمامی حقوق مربوط به این وب‌سایت، متعلق به شرکت <a
                    className="text-red-600 font-bold" href="https://asredade.com">عصرداده</a> می باشد.</p>
            </div>
        </Container>


    </div>
}
export default DivarInternalReport;